import React from "react";

// 年間テスト
const testingDate =[
    '',
    '9月23日(火)',
    '10月19日(日)',
    '11月24日(月)',
    '12月14日(日)',
    '1月18日(日)'
]

const ScheduleTable  = () => {
    return (
        <>
            <table className="table table-bordered"> 
            <tbody>    
                {testingDate.map((date, i) =>
                    <> 
                    {   i!==0 && 
                            <tr >
                                <td key={i}>第{i}回</td>
                                <td >{date}</td>
                            </tr>
                    }
                    </>
                )}
            </tbody>
            </table>
        </>
    );
}

export default ScheduleTable;